@if (icon) {
  <app-svg-icon
    class="text-button__icon"
    [src]="icon"
    [svgStyle]="{ 'width.px': '20', 'height.px': '20' }"
  ></app-svg-icon>
}
{{label | translate}}
